import { Tooltip } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import { FormatType } from '../../types';
import { getFormatter } from '../../utilities';
import styles from './sankey-chart.module.css';
import type { SankeyNodeValidated } from './types';

type SankeyNodeTooltipProps = PropsWithChildren & {
  node: SankeyNodeValidated;
};
export const SankeyNodeTooltip = ({
  node,
  children,
}: SankeyNodeTooltipProps) => {
  return (
    <Tooltip
      label={<TooltipContent node={node} />}
      placement="top"
      padding="8px 12px"
      borderRadius="4px"
      bg="var(--ui-text-normal, #2d426a)"
      hasArrow
      data-testid="sankey-chart__node-tooltip"
    >
      {children}
    </Tooltip>
  );
};

const format = getFormatter(FormatType.INTEGER);

const TooltipContent = ({ node }: { node: SankeyNodeValidated }) => {
  return (
    <div className={styles.tooltipContent}>
      {node.id}: {format(node?.value ?? 0)}
    </div>
  );
};
